import { createSlice } from "@reduxjs/toolkit";

const builderSlice = createSlice({
    name: "builder",
    initialState: {
        adminConfig: null,
        clientConfig: null,
    },
    reducers: {
        setBuilderConfig(state, action) {
            if (action.payload?.adminConfig !== undefined) state.adminConfig = action.payload.adminConfig;
            if (action.payload?.clientConfig !== undefined) state.clientConfig = action.payload.clientConfig;
        },
    },
});

export const { setBuilderConfig } = builderSlice.actions;
export const builderReducer = builderSlice.reducer;
